import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Subject } from 'rxjs';
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/catch';
import { catchError,take } from 'rxjs/operators';
import { throwError } from 'rxjs';


// services
import { ErrorHandler } from './error-handler.service';
import { DataStorageService } from './data-storage.service';
import { UtilityService } from './utility.service';
// path globals
import {
  API_PATH,SUBSCRIPTION_KEY,
  VERIFY_USER, TOKEN, LOGIN, SEND_RESET_PASSWORD, SEND_VERIFY_SMS, SEND_MAGIC_LINK, VALIDATE_SMS_CODE, VALIDATE_USER, RESET_PASSWORD, SET_PASSWORD, UPDATE_USER_DETAILS, RESEND_REGISTER_EMAIL, GET_USER_BY_ID, GET_USERS, RESEND_COMMS
} from '../globals';
// store
import { Store } from '@ngrx/store';
// models
import { AppState } from '../../booking/models/app-state.interface';
import { GetUserByRoles } from '../models/get-user-by-roles.interface';
// enum
import { UserAdminRoles } from '../enum/user-admin-roles.enum';
// shared service
import { SharedService } from './shared-service.service';
import { RESET_USER_STATE, UPDATE_ADMIN_USERS, UPDATE_AMEND_CARDS, UPDATE_MARKETING_ENROLMENT, UPDATE_NEW_USER, UPDATE_SURVEY_MARKETING_ENROLMENT, UPDATE_TOKEN, UPDATE_TOKEN_VALID, UPDATE_USER, UPDATE_USER_ADDRESSES, UPDATE_USER_EMAIL, UPDATE_USER_HAS_PASSWORD, UPDATE_USER_LOGGED_IN, UPDATE_USER_PERMISSIONS, UPDATE_USER_ROLE } from '@shared/reducers/user.reducer';
import { USER_LOADED } from '@shared/reducers/loading-status.reducer';

declare var ga: any;
declare var exponea: any;
declare var libphonenumber: any;

interface CheckEmailRequest {
  emailAddress: string;
}
interface ResetPassword {
  urlResetCode: string;
  newPassword: string;
};
interface SetPassword {
  emailAddress: string;
  newPassword: string;
};
interface UpdateUserDetails {
  userId?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  title?: string;
  jobTitle?: string;
  biography?: string;
  driverNumber?: string;
  contactNumber?: string;
  mobileNumberCountryCode: string;
  hasMarketingEnrolment?: boolean;
  mobileNumber: string;
  organisationId?: string;
  locationId?: string;
  hasSurveyMarketingEnrolment?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private _token: string;
  private _requestCount = 0;

  public verifyUserSubject$: Subject<any> = new Subject();
  public validateUserSubject$: Subject<any> = new Subject();
  public userSubject$: Subject<any> = new Subject();
  public savedUserSubject$: Subject<any> = new Subject();
  public tokenSubject$: Subject<any> = new Subject();
  public forgotPasswordEmailSent$: Subject<any> = new Subject();
  public resendEmailSent$: Subject<any> = new Subject();
  public verifySmsSent$: Subject<any> = new Subject();
  public magicLinkSent$: Subject<any> = new Subject();
  public validateSmsCode$: Subject<any> = new Subject();
  public resetPasswordSubject$: Subject<any> = new Subject();
  public updateUserSubject$: Subject<any> = new Subject();
  public userIDSubject$: Subject<any> = new Subject();
  public userLoggedOut$: Subject<any> = new Subject();

  public userArr: Array<any> = [];

  constructor (
    private _http: HttpClient,
    private _appStore: Store<AppState>,
    private _errorService: ErrorHandler,
    private _dataStorageService: DataStorageService,
    private _utilityService: UtilityService,
    private _sharedService: SharedService
  ) {

  };

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe(s => state = s);
    return state;
  }

  createCustomAuthorizationHeader(headers: HttpHeaders) {
    const value =  this._utilityService.getCsValue();
   // headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY)
    headers = headers.set('API_KEY', value);
    return headers;
  }

  createAuthorizationHeader(headers : HttpHeaders, tokenFromCall?) {
    const userToken = typeof this._token === 'undefined' ? tokenFromCall : this._token;
    headers = headers.set('Authorization', 'bearer ' + userToken);
    return headers;
  }

  checkEmail(email: string) {
    const request: CheckEmailRequest = { emailAddress: email };
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this._http
      .post(API_PATH + VERIFY_USER, request, {headers:headers})
      .subscribe((res:any) => {
        // // console.log(res);
        this.verifyUserSubject$.next(res);
      },
      err => {
        // this.verifyUserSubject$.next(Observable.throw(err));
        this.verifyUserSubject$.next(err);
        this._errorService.handleError(err);
        return;
      });
  }

  validateEmail(email: string) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    const request: CheckEmailRequest = { emailAddress: email };
    this._http
      .post(API_PATH + VALIDATE_USER, request, {headers: headers})
      .subscribe((res: any) => {
        // // console.log(res);
        this.validateUserSubject$.next(res);
        return res;
      },
      err => {
        // this.validateUserSubject$.next(Observable.throw(err));
        this.validateUserSubject$.next(err);
        this._errorService.handleError(err);
        return;
      });
  }

  private storeCookie(isAdmin: boolean) {
    this._token = this._token === 'undefined' || typeof this._token === 'undefined' ? this.getState(this._appStore).userReducer.userDetails.userToken : this._token;
    this._dataStorageService.setUserCookie(this._token, isAdmin);
  }

  getToken(params: string, storeCookie: boolean, isGuest: boolean, email: string) {
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Content-Type', 'application/x-www-form-urlencoded')
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this._http
      .post(API_PATH + TOKEN, params, {headers: headers})
      .subscribe((res:any) => {
        this.loginAccessToken(res.access_token, storeCookie, isGuest);
      },
      err => {
        // this.tokenSubject$.next(Observable.throw(err));
        this.tokenSubject$.next(err);
        this._errorService.handleError(err);
        return;
      });
  }

  loginAccessToken(accessToken: string, storeCookie: boolean, isGuest: boolean) {
    this._token = accessToken;
    this._appStore.dispatch(UPDATE_TOKEN({ userToken: this._token }));
    this._appStore.dispatch(UPDATE_TOKEN_VALID({ userTokenValid: true }));
    this.loginUser(storeCookie, isGuest, this._token);
  }

  loginUser(storeCookie: boolean, isGuest: boolean, token: string) {

    token = typeof token === 'undefined' ? null : token;
    if (token === null) { return; }

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    this._http
      .get(API_PATH + LOGIN + '?cache=' + (Math.random() * 1000000), {headers: headers})
      .subscribe((res:any) => {

        const userObj = res;
        this._dataStorageService.setCookie('portrE', btoa(userObj.user.emailAddress));

        if (token) {
          this._appStore.dispatch(UPDATE_TOKEN({ userToken: token }));
          }
          this._appStore.dispatch(UPDATE_TOKEN_VALID({ userTokenValid: true }));
        this._appStore.dispatch(UPDATE_USER({ currentUser: userObj.user }));
        this._appStore.dispatch(UPDATE_USER_LOGGED_IN({ userLoggedIn: true }));
        this._appStore.dispatch(UPDATE_USER_EMAIL({ userEmail: userObj.user.emailAddress }));
        this._appStore.dispatch(UPDATE_USER_ADDRESSES({ userAddresses: userObj.locations }));

        this._appStore.dispatch(UPDATE_MARKETING_ENROLMENT({ hasMarketingEnrolment: userObj.user.hasMarketingEnrolment }));
        this._appStore.dispatch(UPDATE_SURVEY_MARKETING_ENROLMENT({ hasSurveyMarketingEnrolment: userObj.user.hasSurveyMarketingEnrolment }));

        // set amend cards
        // used for charging amends
        const userCards = res.user.cardDetails;
        if (typeof userCards !== 'undefined' && userCards !== null) {
          this._appStore.dispatch(UPDATE_AMEND_CARDS({ amendUserCards: userCards }));
        } else {
          this._appStore.dispatch(UPDATE_AMEND_CARDS({ amendUserCards: null }));
        }
        ga('set', 'dimension1', 'Logged in');
        ga('send', 'pageview');

        if (isGuest) {
          this._appStore.dispatch(UPDATE_USER_ROLE({ userRole: 'GUEST' }));
        } else {

          const descriptionArr = [];
          for (const item of userObj.user.userRoles){
            descriptionArr.push(item.description.toUpperCase());
          }
          const userRoles = descriptionArr.join();
          this._appStore.dispatch(UPDATE_USER_ROLE({ userRole: userRoles }));
          this.updateUserPermissions(descriptionArr, storeCookie);
        }

        this._appStore.dispatch(USER_LOADED({ userLoaded: true }));
        this.userSubject$.next(userObj);
        this.savedUserSubject$.next(true);
      },
      err => {
        // this.userSubject$.next(Observable.throw(err));
        this.userSubject$.next(err);
        this.savedUserSubject$.next(false);
        this._errorService.handleError(err);
        return;
      });
  }

  resendUserEmail(email: string, bookingReference: string, bookingJourneyReference: string) {
    const request = {
      emailAddress: [email],
      bookingReference: bookingReference,
      bookingJourneyReference: bookingJourneyReference,
      emailType: "CompleteBookingEmail "
    }

    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this._http
      .post(API_PATH + RESEND_REGISTER_EMAIL, request, {headers: headers})
      .subscribe(res => {
        this.resendEmailSent$.next(true);
      },
      err => {
        this.resendEmailSent$.next(err);
        this._errorService.handleError(err);
        return;
      });
  }

  resendComms(email: string, bookingReference: string) {
    const token = this.getState(this._appStore).userReducer.userDetails.userToken;

    const request = {
      emailAddress: email,
      bookingReference: bookingReference,
      emailType: "CompleteBookingEmail"
    }

    let headers = new HttpHeaders()
      .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    this._http
      .post(API_PATH + RESEND_COMMS, request, {headers: headers})
      .subscribe(res => {
        this.resendEmailSent$.next(true);
      },
      err => {
        this.resendEmailSent$.next(err);
        this._errorService.handleError(err);
        return;
      });
  }



  sendResetPassword(email: string, isRegister?: Boolean) {
    let request;

    let thisPath = '';

    if (isRegister) {
      thisPath = RESEND_REGISTER_EMAIL;
      request = {
        emailAddress: [email],
        emailType: 'AccountConfirmationDirect',
        languageCode: this.getState(this._appStore).copyReducer.languageCode
      };
    } else {
      thisPath = SEND_RESET_PASSWORD;
      request = {
        emailAddress: email,
        languageCode: this.getState(this._appStore).copyReducer.languageCode
      };
    }

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this._http
      .post(API_PATH + thisPath, request, {headers: headers})
      .subscribe(res => {
        this.forgotPasswordEmailSent$.next(true);
      },
      err => {
        // this.forgotPasswordEmailSent$.next(Observable.throw(err));
        this.forgotPasswordEmailSent$.next(err);
        this._errorService.handleError(err);
        return;
      });

  }

  sendVerifySms(emailAddress: string) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    headers = this.createCustomAuthorizationHeader(headers);

    const request: any = {
      emailAddress: emailAddress,
      languageCode: this.getState(this._appStore).copyReducer.languageCode
  };

    this._http
      .post(API_PATH + SEND_VERIFY_SMS, request, {headers: headers})
      .subscribe((res:any) => {
        this.verifySmsSent$.next(res.mobilePhoneNumber);

      },
      err => {
        this.verifySmsSent$.next(false);
        this._errorService.handleError(err);
        return;
      });

  }

  sendMagicLink(emailAddress: string, sessionID?: string) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    headers = this.createCustomAuthorizationHeader(headers);

    const request: any = {
        emailAddress: emailAddress,
        languageCode: this.getState(this._appStore).copyReducer.languageCode
    };

    if (sessionID) {
      request.sessionId = sessionID;
    }

    this._http
      .post(API_PATH + SEND_MAGIC_LINK, request, {headers: headers})
      .subscribe(res => {
        this.magicLinkSent$.next(true);
      },
      err => {
        this.magicLinkSent$.next(false);
        this._errorService.handleError(err);
        return;
      });
  }

  validateSmsCode(code: string, emailAddress: string) {

    const request = {
      token: code,
      emailAddress: emailAddress
    };
    const storeCookie = true;
    const isGuest = false;
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);


    headers = this.createCustomAuthorizationHeader(headers);

    this._http
      .post(API_PATH + VALIDATE_SMS_CODE, request, {headers: headers})
      .subscribe((res:any) => {
        const returnedData = res;
        const token = returnedData.token;
        const parsedToken = this.parseReturnedData(token);

        this.validateSmsCode$.next(true);

        this.loginAccessToken(parsedToken.access_token, storeCookie, isGuest);
      },
      err => {
        // this.validateSmsCode$.next(Observable.throw(err));
        this.validateSmsCode$.next(err);

        this._errorService.handleError(err);
        return;
      });
  }

  resetPassword(password: string, code: string) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);


    const request: ResetPassword = { newPassword: password, urlResetCode: code};
    this._http
      .post(API_PATH + RESET_PASSWORD, request, {headers:headers})
      .subscribe(res => {
        this.resetPasswordSubject$.next(true);
      },
      err => {
        // this.resetPasswordSubject$.next(Observable.throw(err));
        this.resetPasswordSubject$.next(err);

        this._errorService.handleError(err);
        return;
      });

  }

  setPassword(emailAddress: string, password: string) {

    const storeCookie = true;
    const isGuest = false;
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createCustomAuthorizationHeader(headers);

    const request: SetPassword = { emailAddress: emailAddress, newPassword: password};

    this._http
      .post(API_PATH + SET_PASSWORD, request, {headers: headers})
      .subscribe((res:any) => {
        const returnedData = res;
        const token = returnedData.token;
        const parsedToken = this.parseReturnedData(token);

        this.loginAccessToken(parsedToken.access_token, storeCookie, isGuest);
      },
      err => {
        this._errorService.handleError(err);
        return;
      });

    this._appStore.dispatch(UPDATE_NEW_USER({ newUser: null}));
  }


  updateUserPreference(userData: any, token: string, userId: string) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    const request: UpdateUserDetails = {
      emailAddress: userData.bookerEmail,
      mobileNumberCountryCode: userData.contactCountryCode,
      mobileNumber: userData.contactPhone,
      hasMarketingEnrolment: userData.hasSmsMarketingEnrolment
    };

    this._http
      .post(API_PATH + UPDATE_USER_DETAILS, request, {headers: headers})
      .subscribe(res => {
        this._errorService.removeModal();
        // this.updateUserSubject$.next(res);
        const token = this.getState(this._appStore).d2dReducer.googlePayToken;
        const { countryCode, phone } = this.parsePhoneNumber(token.shippingAddress.phoneNumber)
        exponea.track('comms_preferences', {
          updatedEmail: token.email === request.emailAddress ? 'No' : 'Yes',
          updatedPhone: request.mobileNumberCountryCode + request.mobileNumber === countryCode + phone ? 'No' : 'Yes'
        });
        exponea.track('consent', {
          action: request.hasMarketingEnrolment ? 'accept' : 'reject',
          email_id: request.emailAddress,
          message: 'Subscribe to our mailing list to be kept informed about promotions, discounts, new services and routes.'
        });
      },
      err => {
        return;
      });
  }

  updateUserAccount(userData: any, token: string, userId: string) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    const request: UpdateUserDetails = {
      title: userData.UserTitle,
      firstName: userData.UserFirstName,
      lastName: userData.UserLastName,
      mobileNumberCountryCode: userData.UserCountryCode,
      mobileNumber: userData.UserPhone,
      userId: userId,
      hasMarketingEnrolment: userData.hasMarketingEnrolment,
      hasSurveyMarketingEnrolment: userData.hasSurveyMarketingEnrolment
    };



    this._http
      .post(API_PATH + UPDATE_USER_DETAILS, request, {headers: headers})
      .subscribe(res => {
        this.updateUserSubject$.next(res);
        const state = this.getState(this._appStore);
        const cs_user = state.userReducer.userDetails;
        const is_cs = cs_user.userRole !== "CUSTOMER";
        const eventAttributes: any = {
          email: cs_user.currentUser.emailAddress,
          cs_amended: is_cs,
          phone_number: '+' + cs_user.currentUser.mobileNumberCountryCode + cs_user.currentUser.mobileNumber,
          cs_name: '',
          cs_email: '',
          amendment_flag: '',
          amend_failed: '',
          fail_reason: '',
          date: '',
          flight_number: '',
        };

        exponea.track('amend_customer_details', eventAttributes);
      },
      err => {
        // this.updateUserSubject$.next(Observable.throw(err));
        this.updateUserSubject$.next(err);

        this._errorService.handleError(err);
        return;
      });
  }

  getUserByID(userId: string, token: string, count?: Number) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    this._http
      .post(API_PATH + GET_USER_BY_ID + '?guid=' + userId, {}, {headers: headers})
      .subscribe(
        (userDetails:any) => {
          if (count) {
            this.userArr.push(userDetails.user);
            this._requestCount ++;
            if (this._requestCount === count) {
              this.userIDSubject$.next(this.userArr);
              this.userArr = [];
              this._requestCount = 0;
            }
          } else {
            this.userIDSubject$.next(userDetails.user);
          }
        },
        err => {
          this._errorService.handleError(err);
          return;
        });
  };

  logout() {
    this._dataStorageService.removeCookie('dataT');
    this._dataStorageService.removeCookie('portrE');
    this._appStore.dispatch(RESET_USER_STATE());
    this.userLoggedOut$.next(true);
    this._dataStorageService.saveData();
  }

  userHasPassword() {
    this._appStore.dispatch(UPDATE_USER_HAS_PASSWORD({ userHasPassword: true }));
  }

  updateUserEmail(email: string) {
    this._appStore.dispatch(UPDATE_USER_EMAIL({ userEmail: email }));
  }

  updateUserPermissions(arr: Array<string>, storeCookie) {

    let value = false;
    arr.map((x: string) => { if (x in UserAdminRoles) { value = true; } });
    this._appStore.dispatch(UPDATE_USER_PERMISSIONS({ userPermissions: { showAdminFeatures: value } }));

    if (storeCookie) { this.storeCookie(value); }
  }

  getAllAdminUsers(arr) {
    const request: GetUserByRoles = { userRoles: [] };
    arr.map((x: string) => { request.userRoles.push(x); });

    this.genericPostPromise(GET_USERS, request).then((userRoleResponse: any) => {
      const listOfUsers: Array<any> = userRoleResponse.liteUsers.map((x) => { return x; });
      this._appStore.dispatch(UPDATE_ADMIN_USERS({ adminUsers: { listOfUsers } }));
      this._sharedService.savedAdminUsers(listOfUsers);
      this._dataStorageService.saveData();
    });
  }

  genericPostPromise(path, request) {

    const token = this.getState(this._appStore).userReducer.userDetails.userToken;

    let headers = new HttpHeaders();
    headers = this.createAuthorizationHeader(headers, token);

    const promise = new Promise((resolve, reject) => {
      this._http
        .post(API_PATH + path, request, {headers: headers})
        .toPromise()
        .then(
          (res:any) => { resolve(res); }
        )
        .catch(
          err => {
            // console.log('error getting admin users');
            return;
          }
        );
    });
    return promise;
  }

  parseReturnedData(value: any) {
    const parsed = JSON.parse(value);
    return parsed;
  }

  parsePhoneNumber(phoneNumber) {
    try {
      const phoneNumberObj = libphonenumber.parsePhoneNumber(phoneNumber);
      const countryCode = phoneNumberObj.countryCallingCode;
      const nationalNumber = phoneNumberObj.nationalNumber;
      return {
        countryCode: countryCode,
        phone: nationalNumber
      };
    } catch (e) {
      console.error('Error parsing phone number:', e);
      return {
        countryCode: '',
        phone: phoneNumber
      };
    }
  }

};
